import React, {useState} from "react";
import _ from "lodash";
import {bindActionCreators} from "redux";
import {connect} from "react-redux";
import ClientSelectActions from "../../action/other/ClientSelectActions";
import WjwClientPng from "../../asset/image/WjwClient.png";
import HospitalClientPng from "../../asset/image/HospitalClient.png";


const getClients = (actions, dataContext) => {
    return [
        {
            key: "wjwClient",
            name: "卫健端",
            image: WjwClientPng,
            onClick: () => actions.selectLogin(_.find(dataContext.hospitals, item => item.hospital.id === "ROOT")),
        },
        {
            key: "hospitalClient",
            name: "医院端",
            image: HospitalClientPng,
            onClick: () => {
                actions.update({
                    isSelectHospital: true,
                });
            },
        },
    ];
};


const Wrapper = ({children, style, onClick}) => {
    return (
        <div
            onClick={onClick}
            style={{
                borderRadius: "12px",
                cursor: "pointer",
                background: "linear-gradient(110.15deg,rgba(25, 119, 255, 0.2) 1.03%,rgba(255, 255, 255, 0.2) 97.6%),#ffffff",
                ...style,
            }}
        >
            {children}
        </div>
    );
};

const ClientSelect = ({clients}) => {
    return (
        <div
            style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
            }}
        >
            <div
                style={{
                    fontWeight: 600,
                    fontSize: 48,
                    color: "#FFF",
                    marginBottom: 65,
                }}
            >
                湖州市卫健委
            </div>
        
            <div
                style={{
                    display: "flex",
                    alignItems: "center",
                }}
            >
                {
                _.map(clients, (item, index) => (
                    <Wrapper
                        onClick={item.onClick}
                        style={{
                            marginRight: index + 1 === _.size(clients) ? 0 : "34px",
                        }}
                    >
                        <div
                            style={{
                                display: "flex",
                                alignItems: "center",
                                padding: "19px 38px",
                                height: 201,
                                width: 411,

                            }}
                        >
                            <div className="logoName"
                                style={{
                                    fontSize: 43,
                                    fontWeight: 700,
                                    color: "#0084ff",
                                }}
                            >
                                {item.name}
                            </div>
                            <div style={{flex: 1}} />
                            <img src={item.image} height="100%" />
                        </div>
                    </Wrapper>
                ))
            }
            </div>
        </div>
    );
};


const HospitalSelect = ({
    hospitals,
    onClick,
}) => {
    return (
        <div
            style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
            }}
        >
            <div
                style={{
                    marginBottom: 68,
                    color: "#FFF",
                    fontSize: 48,
                    fontWeight: 600,
                }}
            >
                医院端
            </div>
            <div
                style={{
                    color: "#FFF",
                    fontSize: 24,
                    marginBottom: 24,
                }}
            >
                请选择要登录的医院名称
            </div>

            <div
                style={{
                    display: "flex",
                    flexDirection: "column",
                }}
            >
                {
                    _.map(hospitals, (item, index) => {
                        return (
                            <Wrapper
                                onClick={() => onClick(item)}
                                style={{
                                    height: 120,
                                    width: 400,
                                    marginBottom: index + 1 === _.size(hospitals) ? 0 : 16,
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                }}
                            >
                                <div
                                    style={{
                                        fontSize: 32,
                                        color: "#0084ff",
                                        fontWeight: 600,
                                        textAlign: "center",
                                    }}
                                >
                                    {item.hospital.name}
                                </div>

                            </Wrapper>
                        );
                    })
                }
            </div>
        </div>
    );
};


function ClientSelectView({
    dataContext,
    actions,
}) {
    const clients = getClients(actions, dataContext);
    let content;
    if (_.find(dataContext.hospitals, item => item.hospital.id === "ROOT") && !dataContext.isSelectHospital) {
        content = <ClientSelect clients={clients} />;
    } else if (!_.find(dataContext.hospitals, item => item.hospital.id === "ROOT") || dataContext.isSelectHospital) {
        content = (
            <HospitalSelect
                onClick={actions.selectLogin}
                hospitals={_.filter(dataContext.hospitals, item => item.hospital?.id !== "ROOT")}
            />
        );
    }

    return (
        <div
            style={{
                position: "fixed",
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                backgroundColor: "#0084ff",
                display: "flex",
                flexFlow: "column nowrap",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                zIndex: 1000,
            }}
        >
            {content}
        </div>
    );
}


export default connect(
    state => ({
        dataContext: state.other.clientSelectViewModel,
    }),
    dispatch => ({
        actions: bindActionCreators(ClientSelectActions, dispatch),
    })
)(ClientSelectView);
